/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ChartType } from '@models/chart.model';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-animation-animate-scale',
  templateUrl: './theme-option-animation-animate-scale.component.html',
  styleUrls: ['./theme-option-animation-animate-scale.component.css']
})
export class ThemeOptionAnimationAnimateScaleComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'animation_animateScale';

  constructor() {}

  receiveValue(value: boolean) {
    this.themeOptions.setOption(this.optionType, value, this.themeOptions.limitedTo(this.optionType));
  }

}
